export function buildDisambiguationFollowUp(
  originalPrompt: string,
  matchedName: string,
  employeeId: string
): string {
  const prompt = originalPrompt.trim()
  const empId = employeeId.trim()
  const name = matchedName.trim()

  if (prompt && name && empId) {
    const pattern = new RegExp(name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi')
    if (pattern.test(prompt)) {
      return prompt.replace(pattern, empId)
    }
  }

  if (prompt && empId) {
    return `${prompt} (use teacher ${empId})`
  }

  return empId ? `assign ${empId}` : prompt
}
